module.exports = __webpack_public_path__ + "img/artist9.79eeb04e.jpeg";